// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__Ow7Nj","right":"styles_right__ODBVP"};